import React, {useState, useEffect, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
import * as XLSX from "xlsx";
import { createRef } from 'react';
import { useForm } from "react-hook-form";
import UserGuide from 'react-user-guide';
import ModalGuide from '../../components/ModalGuide';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";
import {useLocation} from 'react-router-dom';
import axios from 'axios';

function PetPointsExchange() {

  const data = useLocation()
  
  const [products, setProducts] = useState([])
  
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  
  const [aliadoId, setAliadoId] = useState("");
  
  const [countryInfo, setCountryInfo] = useState({})
  const [user, setUser] = useState({})
  const [aliado, setAliado] = useState({})
  const [product, setProduct] = useState({})
  const [petPoints, setPetPoints] = useState({})

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState(false);

  const [searchName, setSearchName] = useState(null)
  const [searchCategorie, setSearchCategorie] = useState(null)
    
    function filterName(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].titulo
        let uLower = u.toLowerCase()

        if( uLower.includes(val.toLowerCase()) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterTipo(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].tipoContenido
        let uLower = u.toLowerCase()

        if( uLower.includes(val.toLowerCase()) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }

    async function getAliado(p){
      setProduct(p)
      try{
        await firebase.db.collection("Aliados").doc(p.aliadoId).get().then((val)=>{
          setAliado(val.data())
        })
      }catch(e){
        console.log("Error: ", e)
      }
    }

    const getProducts = async(a) =>{
      let tipos = [];
      await firebase.db.collection('CanjeContenido').where("aliadoId", "!=", a).get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
          tipos.sort()
        })

        let allList = tipos
        let filteredName = searchName ? filterName(allList, searchName) : allList
        let filteredType = searchCategorie ? filterTipo(filteredName, searchCategorie) : filteredName

        setProducts(filteredType.sort((a, b) => b.createdOn - a.createdOn))

      })
    }
    async function getPetPoints(u){
      try{
        await firebase.db.collection("Aliados").doc(u.aliadoId).collection("Petpoints").doc(u.aliadoId).onSnapshot((val)=>{
          setPetPoints(val.data())
        })
      }catch(e){
        console.log("Error: ", e)
      }
    }
    
    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert" style={{ zIndex: "1112" }}>
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }
    
    useEffect(() => {
      firebase.getCurrentUser().then((val)=>{
        setUser(val)
        getPetPoints(val)
        setAliadoId(val.aliadoId)
        getProducts(val.aliadoId)
        firebase.getCountryInfo(val.pais).then((val)=>{
          setCountryInfo(val.data()) 
        })
      });        
    }, [])


    return (
      
        <div className="main-content-container container-fluid px-4">
          {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
          {success && <SuccessComponent msg={successMsg === "" ? "Producto cargado exitosamente" : successMsg}/>}

            <div className={`sidebar-activation ${activeSidebar && "active"}`}>
              <div className="sidebar-activation-wrapper">
                <div className="sidebar-activation-header">
                  <div onClick={()=>{ setActiveSidebar(false); setProduct({}) }}  className="sidebar-activation-header-btn cursor-pointer">
                    <i className="material-icons">close</i>
                  </div>
                  <div className="right-side-info-title">
                    {product.tipoContenido}
                  </div>
                </div>
                
                <div className="sidebar-exchange-body fadeIn">
                  <div className="sidebar-exchange-body-grid">
                    
                    <div className={`sidebar-exchange-photo${product.tipoContenido === "Servicio" ? "-wide" : ""}`}> <img src={product.urlImagen}/> </div>

                    <div style={{width: "100%", marginBottom: "10px"}}>
                      <div className="row no-gutters align-items-center">
                          {/* <div className="col-lg-1"> */}
                              <img style={{width: "65px", height: "65px", borderRadius: "18px", marginRight: "20px"}} src={aliado.avatar} className="calendar-component-right-info-appointment-header-img" />
                          {/* </div> */}
                          <div className="col-lg-8" style={{textAlign: "start"}} >
                              <p className="mb-1 color-primary">{aliado.nombre}</p>
                              <p className="mb-1 calendar-component-appointment-card-title">{aliado.telefono}</p>
                          </div>
                      </div>
                    </div>
                    
                    <div className="sidebar-exchange-title">{product.titulo}</div>
                    <div className="sidebar-exchange-p">{product.descripcion}</div>
                    { product.tipoContenido !== "Servicio" && <div className="sidebar-exchange-p">{product.presentacion}</div> }
                    <div className="sidebar-exchange-price">{product.precioAliado} Pet Points</div>

                  </div>
                </div>

                <div className="sidebar-activation-footer">
                  <div className="btn btn-block btn-primary" onClick={()=>{ 
                    exchangeProduct()
                  }}>Canjear</div>
                </div>
              </div>
            </div>

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="col">
                    <p className="page-title bold"><Link className="color-white light" to="/configuration">Configuración</Link> <span>Canje de Pet Points</span> </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0 level-1">
                <div className="row align-items-center justify-content-space-around level-2">
                  {/* <i onClick={()=>{setStepStart(true)}} className="material-icons color-white display-5 cursor-pointer">help_outline</i> */}
                </div>
              </div>
            </div>

            <div className="my-3 row no-gutters align-items-center">
                
                <div className="form-group mr-3 mb-0 col-lg-2">
                    <input type="text" placeholder="Nombre" className="form-control" onChange={(e)=>{ setSearchName(e.target.value) }}/>
                </div>

                <div className="form-group mr-3 mb-0 col-lg-2">
                  <select className="form-control" onChange={(e) => { setSearchCategorie(e.target.value) }}>
                    <option value="">Tipo</option>
                    <option value="Producto">Producto</option>
                    <option value="Servicio">Servicio</option>
                    <option value="Todos">Todos</option>
                  </select>
                </div>

                <button className="btn btn-primary mr-3 col-lg-1" onClick={()=>{getProducts( user.aliadoId )}}><i className="material-icons">search</i></button>

                <div className="row no-gutters">
                  <p className="bold color-primary mr-3 mb-0">Tienes disponibles</p>
                  <p className="color-secondary mr-3 mb-0">{petPoints ? petPoints.ppAcumulados : "Cargando"}</p>
                  <p className="bold color-primary mr-3 mb-0">Pet Points</p>
                </div>

            </div>
            
            <div className="position-relative">

                <div className="row-products-container-title">
                    <div className="row-products-container-img"></div>
                    <div className="row-products-container-body">
                        <p className="row-products-container-title-title-sm">Nombre del producto</p>
                        <p className="row-products-container-title-desc">Descripción</p>
                        <p className="row-products-container-title-price">Precio</p>
                        <p className="row-products-container-title-price">Tipo</p>
                    </div>
                </div>
                
                { products.length > 0 ? products.map((prod) => {                    
                  return(
                    <div onClick={()=>{ setActiveSidebar(true); getAliado(prod) }} className="row-products-container" key={prod.productoId}>
                      <img src={prod.urlImagen} alt="" className="row-products-container-img" />
                      <div className="row-products-container-body">
                        <p className="row-products-container-p-title-sm" >{prod.titulo}</p>
                        <p className="row-products-container-p-desc">{prod.descripcion}</p>
                        <p className="row-products-container-p-price">{prod.precioAliado}</p>
                        <p className="row-products-container-p-title">{prod.tipoContenido}</p>
                      </div>
                    </div>
                  )
                  }) : <div className="text-center"><p>No hay productos</p></div> 
                }
                
            </div>

          </div>
    )

    async function exchangeProduct(){
      // await axios.get(`https://us-central1-priority-pet.cloudfunctions.net/sendInvitationEmail?dest=${""}`)
      firebase.db.collection("Aliados").doc(user.aliadoId).collection("Petpoints").doc(user.aliadoId).update({
        ppAcumulados: petPoints.ppAcumulados - product.precioAliado
      })

      const oid = moment().valueOf().toString()

      let order = {
        createdOn: moment().toDate(),
        delivery: 0,
        nombreComercial: user.nombreComercial,
        oid: oid,
        pais: user.pais,
        ppGeneradosD: "",
        precio: product.precioAliado,
        status: "Pagada",
        tipoOrden: "Canje",
        aliadoId: aliadoId,
        aliado: true,
        user:  user.nombre,
        statusPago: "Pagada"
      }


      firebase.db.collection("Ordenes").doc(oid).set({
        ...order
      })

      firebase.db.collection("Ordenes").doc(oid).collection("Items").doc(product.productoId).set({
        iId: oid + 1,
        nombreComercial: user.nombreComercial,
        precio: product.precioAliado,
        productoId: product.productoId,
        titulo: product.titulo,
        aliadoId: aliadoId,
        aliado: true,
      })

      setSuccessMsg("Producto canjeado exitosamente")
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 4000);
    }

}

export default PetPointsExchange
